import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getGeneralList } from 'services/intakeforms/leadIntakeService';
import { convertObjectToQuery } from 'utils/utils';
import { useIntakeFormContext } from '../Context/IntakeFormContext';
export default function useGetListAPI() {
  const location = useLocation();
  const {
    practiceAreaList,
    setPracticeAreaList,
    roles,
    setRoles,
    contactList,
    setContactList,
    setContactCustomFields,
    contactCustomFields,
  } = useIntakeFormContext();

  const getGeneralListService = (type, id) => {
    const token = new URLSearchParams(location.search).get('token');
    getGeneralList(convertObjectToQuery({ token, list_module: type, id }))
      .then((res) => {
        if (type === 'relation_role') {
          setRoles(res.data);
        } else if (type === 'practice_area') {
          setPracticeAreaList(res.data);
        } else if (type === 'case_contact_relation') {
          setContactList(res.data?.filter((v) => v?.contact_id !== id));
        } else if (type === 'contact_custom_fields') {
          setContactCustomFields(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return { getGeneralListService, practiceAreaList, roles, contactList, contactCustomFields };
}
